import { CustomerIcon } from "@/components/CustomerIcon";
import { Icon } from "@/components/Icon";
import SubLayout from "@/components/SubLayout";
import { List, Switch } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.scss";
import { useSetup } from "./logic";
export function PageUserSecurity() {
  const navigate = useNavigate();
  const store = useSetup();

  return (
    <SubLayout title={"安全中心"} header={{ extra: <CustomerIcon /> }}>
      <section className={styles.content}>
        <List className={styles.list}>
          <List.Item>
            <div
              className={styles.item}
              onClick={() =>
                !store.isBindPhone ? navigate("/user_phone") : null
              }
            >
              <div className={styles.label}>手机号码</div>
              <div className={styles.space}></div>
              <div className={styles.value}>
                {store.isBindPhone ? store.userinfo.phone : "未绑定手机号码"}
              </div>
              {!store.isBindPhone ? (
                <div className={styles.icon}>
                  <Icon name={"user-arrow-right"} size={"20px"} />
                </div>
              ) : null}
            </div>
          </List.Item>
          <List.Item>
            <div
              className={styles.item}
              onClick={() =>
                store.checkIfSetUsername("/user_login_psw", store.isBindPwd)
              }
            >
              <div className={styles.label}>登录密码</div>
              <div className={styles.space}></div>
              <div className={styles.value}>
                {store.isBindPwd ? "修改登录密码" : "设置登录密码"}
              </div>
              <div className={styles.icon}>
                <Icon name={"user-arrow-right"} size={"20px"} />
              </div>
            </div>
          </List.Item>
          <List.Item>
            <div
              className={styles.item}
              onClick={() =>
                store.checkIfSetUsername("/user_pay_psw", store.isBindPwd)
              }
            >
              <div className={styles.label}>资金密码</div>
              <div className={styles.space}></div>
              <div className={styles.value}>
                {store.isBindPwd ? "修改资金密码" : "设置资金密码"}
              </div>
              <div className={styles.icon}>
                <Icon name={"user-arrow-right"} size={"20px"} />
              </div>
            </div>
          </List.Item>
          <List.Item>
            <div className={styles.item}>
              <div className={styles.label}>谷歌身份验证</div>
              <div className={styles.space}></div>
              <div className={styles.icon}>
                <Switch
                  checked={store.isGoogleAuthOpen}
                  onChange={store.onGoogleAuthInput}
                  style={{ "--checked-color": "#01B14E" }}
                />
              </div>
            </div>
          </List.Item>
        </List>
      </section>
    </SubLayout>
  );
}
